import React from 'react';
import {Link} from 'react-router-dom';

export default class FeatureFive extends React.Component {
    componentDidMount() {

        const $ = window.$;

        if ($(".tabs-box").length) {
            $(".tabs-box .tab-buttons .tab-btn").on("click", function (e) {
              e.preventDefault();
              var target = $($(this).attr("data-tab"));
        
              if ($(target).is(":visible")) {
                return false;
              } else {
                target
                  .parents(".tabs-box")
                  .find(".tab-buttons")
                  .find(".tab-btn")
                  .removeClass("active-btn");
                $(this).addClass("active-btn");
                target
                  .parents(".tabs-box")
                  .find(".tabs-content")
                  .find(".tab")
                  .fadeOut(0);
                target
                  .parents(".tabs-box")
                  .find(".tabs-content")
                  .find(".tab")
                  .removeClass("active-tab");
                $(target).fadeIn(300);
                $(target).addClass("active-tab");
              }
            });
        }
    }
    render(){
        let publicUrl = process.env.PUBLIC_URL+'/'
        return (
            <>
                <section className="feature-three-sec clearfix">
                    <div className="feature-three__bg" style={{backgroundImage: 'url('+publicUrl+'assets/images/backgrounds/features-v1-bg.png)'}}>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="feature-three__title">
                                    <div className="sec-title">
                                        <div className="sec-title__tagline">
                                            <h6>More About Us</h6> <span className="right"></span>
                                        </div>
                                        <h2 className="sec-title__title">We Supply Marine & Industrial<br />Machineries & Solutions </h2>
                                        <p className="sec-title__text">Providing trusted, reliable and high-quality machinery & automation solutions for marine and industrial sectors.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-xl-12">
                                <div className="feature-three__tab tabs-box">
                                    <div className="feature-three__tab-button">
                                        <ul className="tab-buttons clearfix">
                                            <li data-tab="#about" className="tab-btn active-btn">
                                                <h3>About Us</h3>
                                            </li>
                                            <li data-tab="#mission" className="tab-btn">
                                                <h3>Our Mission</h3>
                                            </li>
                                            <li data-tab="#vision" className="tab-btn">
                                                <h3>Our Vision</h3>
                                            </li>
                                        </ul>
                                    </div>


                                    <div className="tabs-content">

                                        {/* ABOUT US TAB */}
                                        <div className="tab active-tab" id="about">
                                            <div className="feature-three__tab-content-item">
                                                <div className="tab-content-inner">
                                                    <div className="row">
                                                        <div className="col-xl-12">
                                                            <div className="tab-content-inner-text">
                                                                <h2>About Us</h2>
                                                                <p>
                                                                    We are suppliers of Marine & Industrial Machinery, Spares, Automation Systems,
                                                                    and Electronic Equipment.
                                                                    <br /><br />
                                                                    At <strong>Nazar Enterprise & Co.</strong>, we are committed to delivering high-quality
                                                                    products and reliable solutions for all your marine and industrial requirements.
                                                                    With extensive experience in the ship-recycling and industrial sectors, we ensure that
                                                                    every product meets professional standards and customer expectations.
                                                                    <br /><br />
                                                                    <strong>Our product range includes:</strong><br />
                                                                    • Machinery Spares<br />
                                                                    • Hydraulic Components<br />
                                                                    • Automation & Control Systems<br />
                                                                    • Navigation Equipment<br />
                                                                    • Electrical & Electronic Systems<br /><br />
                                                                    We aim to serve our valued customers with professionalism, transparency, and long-term trust.
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* MISSION TAB */}
                                        <div className="tab" id="mission">
                                            <div className="feature-three__tab-content-item">
                                                <div className="tab-content-inner">
                                                    <div className="row">
                                                        <div className="col-xl-5 col-lg-6">
                                                            <div className="tab-content-inner-text">
                                                                <h2>Our Mission</h2>
                                                                <p>
                                                                    Our mission is to provide dependable marine and industrial solutions that enhance
                                                                    operational efficiency and safety for our clients. We are dedicated to supplying
                                                                    high-quality machinery, automation components, and electronic systems at competitive
                                                                    prices while maintaining honesty and reliability.
                                                                    <br /><br />
                                                                    By focusing on continuous improvement and strong customer relationships, we aim to
                                                                    become a trusted global partner in the marine and industrial market.
                                                                </p>
                                                                <div className="btn-box">
                                                                    <Link to={process.env.PUBLIC_URL + `/`} className="thm-btn" data-text="Get Started +">Get Started +</Link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-7 col-lg-6">
                                                            <div className="tab-content-inner-img">
                                                                <img src={publicUrl+"assets/images/resources/feature-v3-img2.png"} alt="" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* VISION TAB */}
                                        <div className="tab" id="vision">
                                            <div className="feature-three__tab-content-item">
                                                <div className="tab-content-inner">
                                                    <div className="row">
                                                        <div className="col-xl-5 col-lg-6">
                                                            <div className="tab-content-inner-text">
                                                                <h2>Our Vision</h2>
                                                                <p>
                                                                    Our vision is to be a leading and globally recognized supplier of marine and industrial
                                                                    machinery, automation systems, and technical components. We aim to continuously upgrade
                                                                    our capabilities and adopt modern technologies to deliver sustainable, future-ready solutions.
                                                                    <br /><br />
                                                                    We envision building long-term partnerships based on integrity, quality, and excellence—
                                                                    serving industries across the world with trust and innovation.
                                                                </p>
                                                                <div className="btn-box">
                                                                    <Link to={process.env.PUBLIC_URL + `/`} className="thm-btn" data-text="Get Started +">Get Started +</Link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-7 col-lg-6">
                                                            <div className="tab-content-inner-img">
                                                                <img src={publicUrl+"assets/images/resources/feature-v3-img3.png"} alt="" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        )
    }
}
